
<!--
  功能：报表-电商报表-计划报表
-->
<template>
  <div>
    <div class="page-title">电商计划报表</div>
    <!-- 表单查询 -->
    <el-form ref="queryFormRef" class="query-form" label-width="70px" :model="queryForm" inline>
      <el-form-item label="日期范围">
        <date-range :timeDate.sync="timeDate" @dateValue="changeTime" :thisClearable="'true'"></date-range>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="queryForm.accountId" @change="changeTime()" filterable clearable placeholder="请选择投放账户">
          <el-option
            v-for="item in accountList"
            :key="item.agentAccountId"
            :label="item.agentAccountName"
            :value="item.agentAccountId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" label-width="0px">
        <el-input v-model="queryForm.searchName" placeholder="请输入计划名称/计划ID" class="input-with-search" style="width:230px;">
          <el-button @click="changeTime()" slot="append" icon="iconfont icon-sousuo"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="" label-width="0px">
        <el-button @click="resetForm" size="medium" type="info">重置选项</el-button>
      </el-form-item>
      <el-form-item class="fr">
        <el-button v-permission="'imgReport:applyImgCustomColumnData'"
        @click="showColDialog" icon="iconfont icon-zidingyiguanli-copy" size="medium" style="margin-right: 13px;" type="primary">
          自定义列
        </el-button>
        <el-button @click="downloadReport"
        :disabled="allData.pageData.length == 0" type="primary" size="medium" icon="iconfont icon-xiazai-copy">下载报表</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <el-table @sort-change="changeSort"
    :data="allData.pageData" v-loading="tableLoading"
    :max-height="tabheight" ref="table" class="roleTable"
    border style="width: 100%">
      <el-table-column label="时间" min-width="188px" prop="reportDate" fixed sortable="custom"></el-table-column>
      <el-table-column v-for="(col,index) in allData.headerData" :fixed="col.fixed"
      :prop="col.dictValue" :label="col.dictName" :key="index" :sortable="col.orderField?'custom':false"
      min-width="160px">
      </el-table-column>
      <el-table-column label="ROI" min-width="100px" prop="roi" fixed sortable="custom"></el-table-column>
      <el-table-column label="GMV" min-width="100px" prop="gmv" fixed sortable="custom"></el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="paging-box" v-if="pageTotal > 0">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80, 100]"
        @size-change="handleSizeChange"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="pageTotal">
      </el-pagination>
    </div>
    <!-- 自定义列对话框 -->
    <set-cols :colsDialogFlag.sync="colsDialogFlag" @dragEnd="dragEnd" :leftMenu="true"
    :listdata="listData" :checkedList="checkedList" :editBtn="editBtn"></set-cols>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import setCols from './../../../components/setCols'
// 公用
import { handleTime, hasPermission } from '@/components/public'
// 组件
import dateRange from './../../../components/common/dateRange'

export default {
  // 组件名称
  name: 'ecPlanReport',
  // 拖动排序
  components: {
    draggable,
    setCols,
    dateRange
  },
  data () {
    return {
      userId: '', // 用户id
      timeDate: [handleTime(new Date(), 6), handleTime(new Date())],
      // 查询表单
      queryForm: {
        timeStar: handleTime(new Date()),
        timeEnd: handleTime(new Date()),
        accountId: '', // 账号id
        searchName: '', // 名称
        orderName: '', // 排序字段
        pageNum: 1,
        pageSize: 10
      },
      pageTotal: 0,
      accountList: [], // 账户列表
      tabheight: null,
      // 表格数据
      tableLoading: false,
      allData: {
        headerData: [],
        pageData: []
      },
      // 自定义列对话框
      colsDialogFlag: false,
      editBtn: true, // 自定义列应用按钮显示隐藏
      // 勾选上的列表
      checkedList: [],
      listData: []
    }
  },
  created () {
    this.getPageData()
  },
  watch: {
  },
  methods: {
    getPageData() {
      this.getAccountList()
      if (hasPermission('dsReport:ad:list')) {
        // 获取计划报表
        this.dsReportListData()
      }
    },
    // 获取账户
    getAccountList() {
      this.$service.post('/api/project/getAccountList4Select').then(res => {
        if (res.code === 200) {
          this.accountList = res.result
        }
      }).catch(Err => {
        console.log(Err)
      })
    },
    // 排序 每次排序会触发
    changeSort(val) {
      console.log('changeSort', val.order)
      // column: {…} order: "ascending" prop: "date"
      // 根据当前排序重新获取后台数据,一般后台会需要一个排序的参数 , 然后请求数据, 重新渲染页面即可.
      if (val.order !== null) {
        if (val.order === 'ascending') {
          this.queryForm.orderName = val.prop.replace(/([A-Z])/g, '_$1').toLowerCase() + ' asc'
        } else {
          this.queryForm.orderName = val.prop.replace(/([A-Z])/g, '_$1').toLowerCase() + ' desc'
        }
      } else {
        this.queryForm.orderName = ''
      }
      this.dsReportListData()
    },
    // 切换分页
    handleCurrentChange (val) {
      this.queryForm.pageNum = val
      this.dsReportListData()
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.queryForm.pageSize = size
      this.dsReportListData()
    },
    // 下载报表
    downloadReport () {
      if (this.timeDate) {
        this.queryForm.timeStar = this.timeDate[0]
        this.queryForm.timeEnd = this.timeDate[1]
      } else {
        this.queryForm.timeStar = ''
        this.queryForm.timeEnd = ''
      }
      // 创建a标签下载
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.$instance.defaults.baseURL + '/api/dsReport/ad/down?accountId=' +
      this.queryForm.accountId + '&searchName=' + this.queryForm.searchName +
      '&timeEnd=' + this.queryForm.timeEnd + '&timeStar=' + this.queryForm.timeStar + '&userId=' + this.userId
      // console.log(link.href)
      link.setAttribute('download', '')
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    // 获取查询数据
    dsReportListData () {
      if (this.timeDate) {
        this.queryForm.timeStar = this.timeDate[0]
        this.queryForm.timeEnd = this.timeDate[1]
      } else {
        this.queryForm.timeStar = ''
        this.queryForm.timeEnd = ''
      }
      // 开启tableLoading
      this.tableLoading = true
      // this.allData.headerData = []
      this.allData.pageData = []
      this.$service.post('/api/dsReport/ad/list', this.queryForm).then(res => {
        if (res.code === 200) {
          // 关闭tableLoading
          this.tableLoading = false
          this.allData.headerData = res.result.headerData
          this.allData.pageData = res.result.pageData
          console.log(this.allData.pageData)
          this.pageTotal = res.result.total
          this.userId = res.result.userId
          // this.allData.pageData.forEach((item, index) => {
          //   if (index !== 0) {
          //     item.reportDate = getTime(new Date(item.reportDate))
          //   }
          // })
          if (this.pageTotal > 5) {
            this.updatetabheight()
          } else {
            this.tabheight = null
          }
        }
      }).catch(Err => {})
    },
    updatetabheight() {
      let height = document.documentElement.clientHeight
      let offsetTop = this.$refs.table.$el.offsetTop
      this.$nextTick(() => {
        this.tabheight = parseInt(height - offsetTop - 83)
      })
    },
    // 选择时间获取表格数据
    changeTime (val) {
      // console.log('changeTime', val)
      if (val) this.timeDate = val
      this.queryForm.pageNum = 1
      this.dsReportListData()
    },
    // 重置选项
    resetForm () {
      this.timeDate = [handleTime(new Date(), 6), handleTime(new Date())]
      this.queryForm.timeStar = handleTime(new Date())
      this.queryForm.timeEnd = handleTime(new Date())
      this.queryForm.accountId = '' // id
      this.queryForm.searchName = '' // 名称
      this.queryForm.orderName = '' // 排序字段
      // 分页
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 10 // 每页显示的数据条数
      this.dsReportListData()
    },
    /*
    * 自定义列的对话框
    */
    // 显示自定义列对话框
    showColDialog () {
      this.checkedList = [] // 清空选中的列
      this.$service.post('/api/adReport/adReportCustomColumnList').then(res => {
        if (res.code === 200) {
          this.listData = res.result.columnData
          this.checkedList = res.result.columnOrderData
          this.colsDialogFlag = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 点击确定，获取拖动排序的列表
    dragEnd () {
      let jsonData = {
        'columnDetailData': this.checkedList
      }
      this.$service.post('/api/adReport/applyCustomColumnData', jsonData).then(res => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.changeTime()
        }
      })
      // 隐藏对话框
      this.colsDialogFlag = false
    }
  }
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/views/report/ecReport/ecPlanReport.vue